module.exports = __webpack_public_path__ + "static/media/share@2x.f623529b.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_31/imgs/share@2x.png
// module id = 914
// module chunks = 0